<template>
  <div id="DyQuillEditor">
    <el-upload
      ref="fileUpload"
      class="avatarUploader"
      :action="baseUrl + '/api/v1/file/upload?biztype='+biztype"
      :show-file-list="false"
      :on-success="handleUploadSuccess"
    />
    <!-- 这两个都是获取值的必要条件： v-model:content  contentType="html" -->
    <quill-editor
      ref="quillEditorRef"
      v-model="content"
      :options="options"
      content-type="html"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    />
  </div>
</template>

<script>
import { quillEditor, Quill } from 'vue-quill-editor'
import { fileUpload } from '@/api/oss'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import imageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', imageResize)
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)

export default {
  name: 'DYQuillEditor',
  components: {
    quillEditor
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    biztype: {
      type: String,
      default: ''
    }
  },
  data() {
    const _this = this
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      content: '',
      options: {
        theme: 'snow', // 使用snow主题
        modules: {
          // 富文本头部栏的功能配置
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 标题
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上下表
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'ltl' }], // 文本方向
              [{ direction: 'rtl' }], // 文本方向
              [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ align: [] }], // 对齐方式
              [{ font: [] }], // 字体种类
              ['clean'], // 清除文本格式
              ['link', 'image', 'video'] // 链接、图片、视频
            ],
            handlers: {
              image: function(value) {
                console.log('image value: ', value)
                console.log('_this.$refs.fileUpload: ', _this.$refs.fileUpload)
                _this.$refs.fileUpload.$children[0].$refs.input.click()
                // _this.$refs['fileUpload'].$children[0].$refs.input.click()
              }
            }
          }
          // // 图片缩放
          // blotFormatter: {
          //   // 可以在这里设置缩放样式
          //   // overlay: {
          //   //    style: {
          //   //        border: '2px solid red',
          //   //    }
          //   // },
          //   toolbar: {
          //     mainClassName: 'blot-formatter__toolbar'
          //   }
          // }
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
            color: 'white'
          },
          modules: ['Resize', 'DisplaySize', 'Toolbar']
        }
      },
      titleConfig: [
        { Choice: '.ql-insertMetric', title: '跳转配置' },
        { Choice: '.ql-bold', title: '加粗' },
        { Choice: '.ql-italic', title: '斜体' },
        { Choice: '.ql-underline', title: '下划线' },
        { Choice: '.ql-header', title: '段落格式' },
        { Choice: '.ql-strike', title: '删除线' },
        { Choice: '.ql-blockquote', title: '块引用' },
        { Choice: '.ql-code', title: '插入代码' },
        { Choice: '.ql-code-block', title: '插入代码段' },
        { Choice: '.ql-font', title: '字体' },
        { Choice: '.ql-size', title: '字体大小' },
        { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
        { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
        { Choice: '.ql-direction', title: '文本方向' },
        { Choice: '.ql-header[value="1"]', title: 'h1' },
        { Choice: '.ql-header[value="2"]', title: 'h2' },
        { Choice: '.ql-align', title: '对齐方式' },
        { Choice: '.ql-color', title: '字体颜色' },
        { Choice: '.ql-background', title: '背景颜色' },
        { Choice: '.ql-image', title: '图像' },
        { Choice: '.ql-video', title: '视频' },
        { Choice: '.ql-link', title: '添加链接' },
        { Choice: '.ql-formula', title: '插入公式' },
        { Choice: '.ql-clean', title: '清除字体格式' },
        { Choice: '.ql-script[value="sub"]', title: '下标' },
        { Choice: '.ql-script[value="super"]', title: '上标' },
        { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
        { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
        { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
        {
          Choice: '.ql-header .ql-picker-item[data-value="1"]',
          title: '标题一'
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="2"]',
          title: '标题二'
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="3"]',
          title: '标题三'
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="4"]',
          title: '标题四'
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="5"]',
          title: '标题五'
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="6"]',
          title: '标题六'
        },
        { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
        {
          Choice: '.ql-size .ql-picker-item[data-value="small"]',
          title: '小号'
        },
        {
          Choice: '.ql-size .ql-picker-item[data-value="large"]',
          title: '大号'
        },
        {
          Choice: '.ql-size .ql-picker-item[data-value="huge"]',
          title: '超大号'
        },
        { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
        { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
        {
          Choice: '.ql-align .ql-picker-item[data-value="center"]',
          title: '居中对齐'
        },
        {
          Choice: '.ql-align .ql-picker-item[data-value="right"]',
          title: '居右对齐'
        },
        {
          Choice: '.ql-align .ql-picker-item[data-value="justify"]',
          title: '两端对齐'
        }
      ]
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.content = newValue
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initTitle()
      this.content = this.value
      console.log('his.$ref.quillEditorRef.quill: ', this.$refs.quillEditorRef)
      this.$refs.quillEditorRef.quill.root.addEventListener('paste', this.customPaste, false)
    })
  },
  methods: {

    // 失去焦点事件
    onEditorBlur(e) {
      console.log(e, '失去焦点事件')
    },
    // 获得焦点事件
    onEditorFocus(e) {
      console.log(e, '获得焦点事件')
    },
    // 内容改变事件
    // html是带标签，text是纯文本
    onEditorChange({ quill, html, text }) {
      // this.content = html
      // console.log('this.content : ', this.content)
      this.$emit('change', html)
    },

    customPaste(e) {
      const clipboardData = e.clipboardData // 粘贴信息
      const types = clipboardData.types // 当前文件类型
      const files = clipboardData.files
      if (types.includes('Files')) {
        e.preventDefault()
        Array.from(e.clipboardData.files).forEach(async(file) => {
          console.log('clipboardData file: ', file)
          // 在这里可以拿到粘贴后的图片与文件信息
          // 在这里做操作
          const formData = new FormData()
          formData.append('file', file)
          const data = await fileUpload(formData, {
            biztype: this.biztype
          })
          console.log('data: ', data)
          this.handleUploadSuccess(data)
        })
      }
    },
    initTitle() {
      for (const item of this.titleConfig) {
        // .editor 是富文本编辑器的类名
        const tip = document.querySelector('.editor ' + item.Choice)
        if (tip) {
          tip.setAttribute('title', item.title)
        }
      }
    },
    handleUploadSuccess(response, file, fileList) {
      const quill = this.$refs.quillEditorRef.quill
      const length = quill.getSelection().index
      // 插入图片，data.url为服务返回的图片链接地址
      quill.insertEmbed(length, 'image', response)
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
    imageHandler() {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/*')
      // 模拟点击，打开文件选择对话框
      input.click()

      // 当用户选择文件后触发的事件
      input.onchange = async() => {
        // 获取用户选择的文件
        const file = input.files ? input.files[0] : null
        if (file) {
          // 创建一个 FormData 对象，用于文件上传
          const formData = new FormData()
          formData.append('file', file)

          try {
            /**
             * @todo 可以选中图片，然后把file文件给后端，后端给存到文件服务器，然后返回一个线上地址
             * 这里的abc替换成你的请求接口方法,也可以使用 axios 发送 POST 请求
             * */
            // todo
            // 使用 axios 发送 POST 请求，将文件上传到服务器,这里的abc替换成你的请求接口方法
            // 可以选中图片，然后把file文件给后端，后端给存到文件服务器，然后返回一个线上地址
            // const res = await abc(formData)
            // // 确保获取到 Quill 编辑器实例
            // const quill = toRaw(quillEditorRef.value).getQuill()
            // if (quill) {
            //   // 获取当前光标位置
            //   const range = quill.getSelection(true)
            //   // 在当前光标位置插入上传的图片
            //   quill.insertEmbed(range.index, 'image', res.data)
            // }
          } catch (error) {
            alert('图片上传失败')
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
#DyQuillEditor {
  width: 100%;
  ::v-deep .ql-editor {
    min-height: 240px;
  }
  .avatarUploader{
    display: none;
  }
}
</style>
